<template>
    <div class="app-footer" :style="сolorSlyles">
        <wrapper>
            <div class="footer-top text-center text-md-start">
                <div class="row w-100">
                    <div class="col-12 col-md-3 footer-top-contact mb-3 mb-md-0">
                        <div class="mb-4">
                            <router-link to="/">
                                <img src="/src/assets/logo.svg" width="248" height="40" alt="Trimm" loading="lazy" />
                            </router-link>
                        </div>
                        <div>{{ $t('headquarters') }}:</div>
                        <div v-html="headquarters"></div>
                    </div>

                    <div class="col-12 col-md-3 d-flex flex-column align-items-center">
                        <div>
                            <div class="text-md-start mb-4">
                                <div class="footer-top-title mb-3">{{ $t('myAccount') }}</div>
                                <div class="footer-top-content d-flex flex-column">
                                    <router-link v-for="(link, index) in myAccountLinks"
                                                 :key="'Customer_link_' + index"
                                                 :to="link.url">{{ link.title }}</router-link>
                                </div>
                            </div>
                            <div class="text-md-start mb-md-0">
                                <div class="footer-top-title mb-3">{{ $t('customerService') }}</div>
                                <div class="footer-top-content d-flex flex-column">
                                    <router-link v-for="(link, index) in customerServiceLinks"
                                                 :key="'Customer_link_' + index"
                                                 :to="link.url">{{ link.title }}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-3 d-flex flex-column">
                        <div class="text-center text-md-start">
                            <div class="footer-top-title mb-3">{{ $t('info') }}</div>
                            <div class="footer-top-content d-flex flex-column">
                                <router-link v-for="(link, index) in informationLinks"
                                             :key="'Customer_link_' + index"
                                             :to="link.url">{{ link.title }}</router-link>
                                <a target="_blank" href="/fuse-coverage.pdf">{{ $t('fuseCoverage') }}</a>
                                <a target="_blank" href="/circuit-breaker-coverage.pdf">{{ $t('circuitCoverage') }}</a>
                                <a target="_blank" rel="nofollow" href="https://trimminc-my.sharepoint.com/:x:/p/sanjana_datla/EaIQfQREMeNCjDVHETsv6BAB8WCUF6lnninQBwtpO1JMFQ?rtime=pAhNwIjs3Eg">LRMS Modbus Registers Information</a>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-3">
                        <div class="footer-top-title my-4 mt-md-0">{{ $t('newsletter') }}</div>

                        <b-form @submit.prevent="submit">
                            <validation-summary :errors="errors"></validation-summary>

                            <form-group :validator="v$.email" class="mb-5">
                                <input id="email-footer" v-model="email" class="form-control w-75 d-inline-block" :placeholder="$t('email')" />
                            </form-group>

                            <div class="gap-2 d-grid">
                                <b-button variant="primary" class="btn-trimm-wide seo-subscribe w-75 mx-auto mx-lg-0" pill @click="submit">{{ $t('subscribe') }}</b-button>
                            </div>
                        </b-form>
                    </div>
                </div>
            </div>
            <div class="footer-bottom d-flex flex-column align-items-center flex-md-row justify-content-center justify-content-md-end border-top border-2" :style="сolorSlyles">
                <div class="me-md-auto mb-2 mb-md-0">Trimm, Inc. © 1922-2024</div>
                <div class="me-md-3 mb-2 mb-md-0">{{ $t('letsConnect') }}</div>

                <social-network :links="socialLinks" />
            </div>
        </wrapper>
    </div>
</template>

<script>
    import useVuelidate from "@vuelidate/core";
    import { required, email } from "@vuelidate/validators";
    import Wrapper from "@/components/common/wrapper.vue";
    import SocialNetwork from "@/components/common/buttons/social-network.vue";
    import formMixin from "@/mixins/form-mixin";
    import { Colors } from "@/constants/color-constants";
    import { newsletterService } from "@/services";
    import { HomePageLinkType } from "@/constants/home-page-link-type-constant";

    export default {
        name: "app-footer",

        components: {
            "wrapper": Wrapper,
            "social-network": SocialNetwork,
        },

        mixins: [formMixin],

        setup() {
            return { v$: useVuelidate() };
        },

        data() {
            return {
                email: '',
                headquarters: '',
                links: []
            }
        },

        validations() {
            return {
                email: { required, email }
            };
        },

        mounted() {
            this.emitter.on("setFooterLinks", (response) => {
                this.links = response.links;
                this.headquarters = response.headquarters;
            });
        },

        methods: {
            async submit() {
                let data = {
                    subscribe: true,
                    email: this.email
                };

                try {
                    //send request
                    await newsletterService.subscribeNewsletter(data);

                    //Show success toast
                    this.$root.successToast(this.$t('subThanks'));

                    //Reset after success
                    this.email = '';
                }
                catch (error) {
                }
            },
        },

        computed: {
            сolorSlyles() {
                return {
                    'background-color': this.$route.meta.useDarkFooter ? Colors.Black : Colors.Brown,
                    '--bs-border-color': this.$route.meta.useDarkFooter ? Colors.Brown : Colors.Black
                }
            },

            customerServiceLinks() {
                return this.links.filter(l => l.home_page_link_type_id === HomePageLinkType.FooterCustomerService);;
            },

            informationLinks() {
                return this.links.filter(l => l.home_page_link_type_id === HomePageLinkType.FooterInformation);
            },

            myAccountLinks() {
                return this.links.filter(l => l.home_page_link_type_id === HomePageLinkType.FooterMyAccount);
            },

            socialLinks() {
                return this.links.filter(l => l.home_page_link_type_id === HomePageLinkType.SocialMediaLink);
            },
        }
    };
</script>